import { render, staticRenderFns } from "./gc-popup-so-part-pick.vue?vue&type=template&id=20684dcb"
import script from "./gc-popup-so-part-pick.vue?vue&type=script&lang=js"
export * from "./gc-popup-so-part-pick.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-so-part-pick.vue?vue&type=style&index=0&id=20684dcb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports